/**
 * Faculty Teaching Assignment
 */
import { z } from 'zod';
import {
  FacultyTeachingAssignmentId,
  FacultyId,
  AcademicYear,
  TermId,
  CourseId,
  SectionId,
  UnixTimestamp,
} from '../types/branded';
import { TeachingRoleSchema } from '../types/enums';

export const FacultyTeachingAssignmentSchema = z.object({
  id: FacultyTeachingAssignmentId,
  facultyId: FacultyId,
  academicYear: AcademicYear,
  termId: TermId.optional(),
  courseId: CourseId.optional(),
  sectionId: SectionId.optional(),
  role: TeachingRoleSchema.optional(),
  divisionLabel: z.string().optional(),
  gradeLabel: z.string().optional(),
  subjectLabel: z.string().optional(),
  room: z.string().optional(),
  homeroom: z.string().optional(),
  studentCount: z.number().int().nonnegative().optional(),
  startAt: UnixTimestamp.nullable().optional(),
  endAt: UnixTimestamp.nullable().optional(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
}).refine((value) => {
  if (!value.courseId && !value.sectionId) return false;
  return true;
}, { message: 'courseId or sectionId is required', path: ['courseId'] })
  .refine((value) => {
    if (!value.startAt || !value.endAt) return true;
    return value.endAt >= value.startAt;
  }, { message: 'endAt must be >= startAt', path: ['endAt'] });

export type FacultyTeachingAssignment = z.infer<typeof FacultyTeachingAssignmentSchema>;
